import Cookies from "js-cookie";
import { AUTH_GATE_CLASS } from "../authGateScript";

const TOKEN_CONFIG = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  EXPIRES_DAYS: 7,
  SECURE: process.env.NODE_ENV === "production",
  SAME_SITE: "lax" as const,
} as const;

/**
 * `<html>` üzerindeki auth geçidi sınıfını cookie ile eşitler.
 *
 * Sınıfı ilk olarak <head>'deki bloklayıcı script koyuyor (authGateScript) ama
 * o yalnızca TAM SAYFA YÜKLEMESİNDE çalışır. Aynı SPA oturumunda giriş/çıkış
 * yapılırsa sınıf olduğu gibi kalırdı; en görünür sonucu şu olurdu: girişten
 * sonra `router.replace("/")` ile ana sayfaya dönen kullanıcıda sınıf hiç
 * eklenmemiş olur ve kişiselleştirme geçidi çalışmaz — düzeltilen "önce anonim
 * ürünler, sonra kişisel ürünler" flash'ı tam da o yolda geri gelirdi.
 *
 * Eşitlemenin burada olmasının sebebi: cookie'yi yazan tek modül bu. Login,
 * register, token refresh ve 401 temizliği dahil tüm yollar buradan geçtiği
 * için ayrıca bir yere kanca takmak gerekmiyor.
 */
const syncAuthGateClass = (hasToken: boolean) => {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle(AUTH_GATE_CLASS, hasToken);
};

export const tokenStorage = {
  setTokens: (accessToken: string, refreshToken: string) => {
    Cookies.set(TOKEN_CONFIG.ACCESS_TOKEN, accessToken, {
      expires: TOKEN_CONFIG.EXPIRES_DAYS,
      secure: TOKEN_CONFIG.SECURE,
      sameSite: TOKEN_CONFIG.SAME_SITE,
    });
    Cookies.set(TOKEN_CONFIG.REFRESH_TOKEN, refreshToken, {
      expires: TOKEN_CONFIG.EXPIRES_DAYS,
      secure: TOKEN_CONFIG.SECURE,
      sameSite: TOKEN_CONFIG.SAME_SITE,
    });
    syncAuthGateClass(!!accessToken);
  },

  getAccessToken: () => Cookies.get(TOKEN_CONFIG.ACCESS_TOKEN),

  getRefreshToken: () => Cookies.get(TOKEN_CONFIG.REFRESH_TOKEN),

  clearTokens: () => {
    Cookies.remove(TOKEN_CONFIG.ACCESS_TOKEN);
    Cookies.remove(TOKEN_CONFIG.REFRESH_TOKEN);
    syncAuthGateClass(false);
  },

  setAccessToken: (accessToken: string) => {
    Cookies.set(TOKEN_CONFIG.ACCESS_TOKEN, accessToken, {
      expires: TOKEN_CONFIG.EXPIRES_DAYS,
      secure: TOKEN_CONFIG.SECURE,
      sameSite: TOKEN_CONFIG.SAME_SITE,
    });
    syncAuthGateClass(!!accessToken);
  },
};
